export const pentagonPeaks = [
  [0, -40],
  [38, -12.4],
  [23.5, 32.4],
  [-23.5, 32.4],
  [-38, -12.4],
];

export const pentagonAreaLines = {
  1: [
    { from: [32, 6.1], to: [4, -16] },
    { from: [4, -16], to: [0, -1.5] },
    { from: [0, -1.5], to: [0, -40] },
    { from: [0, 3], to: [0, -1.5] },
    { from: [0, 3], to: [24.3, 30] },
    { from: [0, 3], to: [-6, 4] },
    { from: [-6, 4], to: [1, 32.4] },
    { from: [-6, 4], to: [-22.5, 32.4] },
    { from: [0, -1.5], to: [-35, -3] },
    { from: [0, -33], to: [-1, -33] },
    { from: [0, -24.5], to: [-1, -24.5] },
    { from: [-1, -33], to: [-1, -24.5] },
  ],
  2: [
    { from: [32, 6.1], to: [4, -16] },
    { from: [4, -16], to: [0, -1.5] },
    { from: [0, -1.5], to: [0, -40] },
    { from: [0, 3], to: [0, -1.5] },
    { from: [0, 3], to: [24.3, 30] },
    { from: [0, 3], to: [-3.5, 3] },
    { from: [-3.5, 3], to: [2.5, 32.4] },
    { from: [-3.5, 3], to: [-11, 8] },
    { from: [-11, 8], to: [-21.5, 32.4] },
    { from: [0, -1.5], to: [-35, -3] },
    { from: [0, -33], to: [-1, -33] },
    { from: [0, -24.5], to: [-1, -24.5] },
    { from: [-1, -33], to: [-1, -24.5] },
  ],
};

export const pentagonAreas = {
  1: [
    {
      points: [
        [0, -40],
        [38, -12.4],
        [32, 6.1],
        [4, -16],
        [0, -1.5],
      ],
      fill: '#DFBFDF',
      name: 'D1',
    },
    {
      points: [
        [4, -16],
        [32, 6.1],
        [24.3, 30],
        [0, 3],
        [0, -1.5],
      ],
      fill: '#FFE8BF',
      name: 'D2',
    },
    {
      points: [
        [0, 3],
        [24.3, 30],
        [23.5, 32.4],
        [1, 32.4],
        [-6, 4],
      ],
      fill: '#BFDFDF',
      name: 'T3',
    },
    {
      points: [
        [-6, 4],
        [1, 32.4],
        [-22.5, 32.4],
      ],
      fill: '#E8CACA',
      name: 'T2',
    },
    {
      points: [
        [-6, 4],
        [-22.5, 32.4],
        [-23.5, 32.4],
        [-35, -3],
        [0, -1.5],
        [0, 3],
      ],
      fill: '#BFDFBF',
      name: 'T1',
    },
    {
      points: [
        [0, -1.5],
        [-35, -3.1],
        [-38, -12.4],
        [0, -40],
        [0, -33],
        [-1, -33],
        [-1, -24.5],
        [0, -24.5],
      ],
      fill: '#BFBFFF',
      name: 'S',
    },
    {
      points: [
        [0, -33],
        [-1, -33],
        [-1, -24.5],
        [0, -24.5],
      ],
      fill: '#FFBFBF',
      name: 'PD',
    },
  ],
  2: [
    {
      points: [
        [0, -40],
        [38, -12.4],
        [32, 6.1],
        [4, -16],
        [0, -1.5],
      ],
      fill: '#DFBFDF',
      name: 'D1',
    },
    {
      points: [
        [4, -16],
        [32, 6.1],
        [24.3, 30],
        [0, 3],
        [0, -1.5],
      ],
      fill: '#FFE8BF',
      name: 'D2',
    },
    {
      points: [
        [0, 3],
        [24.3, 30],
        [23.5, 32.4],
        [2.5, 32.4],
        [-3.5, 3],
      ],
      fill: '#BFDFDF',
      name: 'T3-H',
    },
    {
      points: [
        [-3.5, 3],
        [2.5, 32.4],
        [-21.5, 32.4],
        [-11, 8],
      ],
      fill: '#E8CACA',
      name: 'C',
    },

    {
      points: [
        [-3.5, 3],
        [-11, 8],
        [-21.5, 32.4],
        [-23.5, 32.4],
        [-35, -3.1],
        [0, -1.5],
        [0, 3],
      ],

      fill: '#BFDFBF',
      name: 'O',
    },
    {
      points: [
        [0, -1.5],
        [-35, -3.1],
        [-38, -12.4],
        [0, -40],
        [0, -33],
        [-1, -33],
        [-1, -24.5],
        [0, -24.5],
      ],
      fill: '#BFBFFF',
      name: 'S',
    },
    {
      points: [
        [0, -33],
        [-1, -33],
        [-1, -24.5],
        [0, -24.5],
      ],
      fill: '#FFBFBF',
      name: 'PD',
    },
  ],
};
